"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortLocale = void 0;
const is_defined_1 = require("./is-defined");
const sortLocale = (_this, _that, locale) => {
    const a = _this ?? '';
    const b = _that ?? '';
    if ((0, is_defined_1.isDefined)(locale)) {
        return a
            .toLowerCase()
            .localeCompare(b.toLowerCase(), locale, { sensitivity: 'accent' });
    }
    return a.toLowerCase() < b.toLowerCase() ? 1 : -1;
};
exports.sortLocale = sortLocale;
